module.exports = __webpack_public_path__ + "Banner_TranquilTeachings-8d51abcc2a81c7ee7d9d0bd29b918339.svg";